<template>
  <b-container>
    <AccordionText
      v-for="accordion in accordions"
      :key="accordion.id"
      :id="accordion.id"
      :title="accordion.title"
      :text="accordion.text"
    ></AccordionText>
  </b-container>
</template>

<script>
import AccordionText from "../../components/AccordionText";

export default {
  data() {
    return {
      accordions: [
        {
          title: "Définition",
          id: "definition",
          text: `Le vertige est une illusion de déplacement du sujet par rapport aux objets environnants ou des objets environnants par rapport au sujet. Il peut créer des instabilités, sensations de déséquilibre, difficultés à la marche. 
De nombreuses causes peuvent être à l’origine de vertiges/troubles de l’équilibre (neurologique, vestibulaire, carence, fatigue importante…). 
`
        },
        {
          title: "Symptômes",
          id: "symptome",
          text: `L’équilibre et la stabilité de notre corps sont performants lorsque le **système visuel**, le **système vestibulaire** et le **système somesthésique** travaillent en collaboration. Si l’un de ces systèmes est défaillant il peut apparaître une sensation de vertige.`
        },
        {
          title: "Traitement",
          id: "traitement",
          text: `Il convient alors de rééduquer ses systèmes afin de mettre en place des compensations pour diminuer les troubles de l’équilibre/vertiges.
L’orthoptiste travaille régulièrement en étroite collaboration avec les ORL, les kinésithérapeutes (spécialisés dans le vestibulaire) et les podologues.
`
        }
      ]
    };
  },
  components: {
    AccordionText
  }
};
</script>
